module.exports = __webpack_public_path__ + "static/media/share_person1.d81964ca.png";